import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchNotification } from './Actions';
const ComponentLink = ({ isLoading = false, id, title, loadNotification }) => (_jsxs("button", Object.assign({ onClick: () => loadNotification(id) }, { children: [title, !isLoading || _jsx("i", { className: "fas fa-spinner-third fa-spin loading" })] })));
ComponentLink.propTypes = {
    isLoading: PropTypes.bool,
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    loadNotification: PropTypes.func.isRequired
};
const mapStateToProps = (state, ownProps) => ({ isLoading: state.notifications.isLoadingNotification === ownProps.id });
const mapDispatchToProps = (dispatch) => ({ loadNotification: (id) => dispatch(fetchNotification(id)) });
export default connect(mapStateToProps, mapDispatchToProps)(ComponentLink);
